import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {
    CompanySummaryTable,
    ItemSummaryTable, PaginationSummaryTable,
} from "features/model/types/hr/getSummaryTable";

export interface GetSummaryTableResponse {
    success: boolean;
    isLoading:boolean;
    data: {
        count: number;
        company: CompanySummaryTable;
        items: ItemSummaryTable[];
        pagination: PaginationSummaryTable;
    };
}

const initialState: GetSummaryTableResponse = {
    success: false,
    isLoading: true,
    data: {
        count: 0,
        company: { id: 0, title: "" },
        items: [],
        pagination: { page: 0, pageSize: 0, pageCount: 0 },
    },
};



const summaryTableSlice = createSlice({
    name: "summaryTable",
    initialState,
    reducers: {
        setSummaryTableData: (
            state,
            action: PayloadAction<GetSummaryTableResponse["data"]>
        ) => {
            state.data = action.payload;
            state.isLoading = false;
        },
        setLoading: (state, action: PayloadAction<boolean>) => {
            state.isLoading = action.payload;
        },

    },
});


export const { setSummaryTableData, setLoading } = summaryTableSlice.actions;

export const summaryTableReducer = summaryTableSlice.reducer;
